import { ApiUrls } from '../endpoints';
import api from '../createApiClient';

export const getAllUsers = async () => {
  try {
    const dataUrl = `${ApiUrls.user}/getAllUsers`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all users:', error);
    throw error;
  }
};

export const getAllUsersInDB = async () => {
  try {
    const dataUrl = `${ApiUrls.user}/getAllUsersInDB`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all users:', error);
    throw error;
  }
};

export const getAllUsersByIssuerId = async (IssuerID) => {
  try {
    const dataUrl = `${ApiUrls.user}/getAllUsersByIssuerId/${IssuerID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting all users:', error);
    throw error;
  }
};

export const getUser = async (UserID) => {
  try {
    const dataUrl = `${ApiUrls.user}/getUserById/${UserID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error getting user:', error);
    throw error;
  }
};

export const createUser = async (data) => {
  try {
    const dataUrl = `${ApiUrls.user}/createUser`;
    const response = await api.post(dataUrl, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error creating user:', error);
    throw error;
  }
};

export const updateUser = async (data) => {
  try {
    const dataUrl = `${ApiUrls.user}/updateUserById`;
    const response = await api.post(dataUrl, data, {
      headers: {
        'Content-Type': 'multipart/form-data'
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error updating user:', error);
    throw error;
  }
};

export const deleteUser = async (UserID) => {
  try {
    const dataUrl = `${ApiUrls.user}/deleteUserById/${UserID}`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting user:', error);
    throw error;
  }
};

export const deleteAllUsers = async () => {
  try {
    const dataUrl = `${ApiUrls.user}/deleteAllUsers`;
    const response = await api.delete(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error deleting all users:', error);
    throw error;
  }
};

export const createAdmin = async (firstName, lastName, email, password) => {
  try {
    const dataUrl = `${ApiUrls.base}/createAdmin`;
    const data = {
      UserFirstName: firstName,
      UserLastName: lastName,
      UserEmail: email,
      password: password
    }
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating admin:', error);
    throw error;
  }
};

export const createUnverifiedUserInAzure = async (firstName, lastName, email, password) => {
  try {
    const dataUrl = `${ApiUrls.user}/createUnverifiedUserInAzure`;
    const data = {
      UserFirstName: firstName,
      UserLastName: lastName,
      UserEmail: email,
      password: password
    }
    const response = await api.post(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error creating user in azure:', error);
    throw error;
  }
};

export const getUserContext = async (authToken, role = null) => {
  try {
    const dataUrl = `${ApiUrls.base}/user-Context`;
    const response = await api.get(dataUrl, {
      params: { role },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching user context:', error);
    throw error;
  }
};

export const uploadProfileImageToAzure = async (file, userId, roles) => {
  const dataUrl = `${ApiUrls.base}/uploadProfileImage`;
  const formData = new FormData();
  formData.append('file', file);
  formData.append('UserID', userId);
  // formData.append('role', role);
  // Determine primary role
  let primaryRole = roles.includes("Admin") ? "Admin"
    : roles.includes("Issuer") ? "Issuer"
      : "User";

  formData.append("role", primaryRole);

  try {
    const response = await api.post(dataUrl, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    if (response.status === 200 && response.data.success) {
      console.log()
      return response.data.data;
    } else {
      throw new Error('Profile image upload failed.');
    }
  } catch (error) {
    console.error('Error uploading profile image:', error);
    throw error;
  }
};

export const getUserProfile = async (data) => {
  try {
    const dataUrl = `${ApiUrls.assignment}/getUserProfile`;
    const response = await api.get(dataUrl, data);
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile:', error);
    throw error;
  }
};

export const getUserProfileWithBadges = async (ProfileID) => {
  try {
    const dataUrl = `${ApiUrls.user}/getUserProfileWithBadges/${ProfileID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error fetching user profile with badges:', error);
    throw error;
  }
};

export const getUserBadges = async (UserID) => {
  try {
    const dataUrl = `${ApiUrls.user}/getUserBadges/${UserID}`;
    const response = await api.get(dataUrl);
    return response.data;
  } catch (error) {
    console.error('Error fetching badges:', error);
    throw error;
  }
};

export const updateProfileId = async (oldProfileID, newProfileID) => {
  try {
    const dataUrl = `${ApiUrls.user}/updateProfileId`;
    const response = await api.post(dataUrl, { oldProfileID, newProfileID });
    return response.data;
  } catch (error) {
    console.error('Error updating profileId:', error);
    throw error;
  }
};
